export const settingRoutes = {
	widget: '/settings/widget/',
	commissions: '/settings/commission-rates/',
	settings: '/settings/',
	store: '/store/'
} as const
